import { render, staticRenderFns } from "./AdminDisplayList.vue?vue&type=template&id=7f497dfe&scoped=true"
import script from "./AdminDisplayList.vue?vue&type=script&lang=js"
export * from "./AdminDisplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f497dfe",
  null
  
)

export default component.exports